'use client'

import classNames from 'clsx'
import { ComponentPropsWithoutRef, forwardRef } from 'react'

import S from '../Table.module.scss'

export interface TableProps extends ComponentPropsWithoutRef<'table'> {
  size?: 'sm' | 'md' | 'lg'
  minWidth?: number | string
  maxWidth?: number | string
}

export const TableRoot = forwardRef<HTMLTableElement, TableProps>(
  (
    { className, children, size = 'md', minWidth, maxWidth, style, ...props },
    ref
  ) => {
    return (
      <table
        {...props}
        ref={ref}
        className={classNames(S.table, S[`size-${size}`], className)}
        style={{
          ...style,
          minWidth: typeof minWidth === 'number' ? `${minWidth}px` : minWidth,
          maxWidth: typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth
        }}
      >
        {children}
      </table>
    )
  }
)

TableRoot.displayName = 'Table'
